<template>
  <div role="button" class="multiselectcomponent input-group form-floating" :class="{'has-validation': errorMessage,'is-invalid': errorMessage}" v-if="valueModel">
    <label :for="'multiSelect-' + $.uid" style="width: 100%" class="">
      {{props.label}} {{ props.required ? '*' : '' }}
    </label>
    <multiselect
      v-model="valueModel.value"
      :name="'multiSelect-' + $.uid"
      :options="options"
      :searchable="props.searchable"
      :close-on-select="props.closeOnSelect"
      :show-labels="props.showLabels"
      :placeholder="props.placeholder"
      :aria-label="props.placeholder"
      :allow-empty="props.allowEmpty"
      :multiple="true"
      selectLabel="Cliquez pour ajouter"
      selectGroupLabel="Cliquez pour sélectionner le groupe"
      deselectLabel="Retirer"
      selectedLabel="Selectionné"
      :required="props.required"
      :class="{'is-invalid': errorMessage}"
      :customLabel="props.customLabel"
    ></multiselect>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useField } from 'vee-validate';
import Multiselect from 'vue-multiselect'

const model = defineModel<string[]>({ required: false, default: [] })
const options = defineModel<Array<unknown>>('options',{ required: false, default: [] })

const props = withDefaults(defineProps<{
  label?: string;
  valueKey?: AllTypeKeys;
  placeholder?: string;
  searchable?: boolean;
  duplicateTagText?: string;
  invalidTagText?: string;
  tagVariant?: string;
  required?: boolean;
  closeOnSelect?: boolean;
  allowEmpty?: boolean;
  showLabels?: boolean;
  tagValidator?: (tag: string) => boolean;
  customLabel?: (option: unknown, label: unknown) => string;
}>(), {
  placeholder: '',
  searchable:false,
  duplicateTagText: 'Choix déjà existant',
  invalidTagText: 'Choix déjà existant',
  tagVariant: 'secondary',
  required: false,
  closeOnSelect: true,
  allowEmpty: true,
  showLabels: true
})

const { value, errorMessage } = props.valueKey !== undefined ? useField<string>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey && value) return value;
  else return model;
})
</script>

<style>
  .multiselectcomponent label {
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
    z-index: 51 !important;
  }
  .multiselectcomponent .multiselect__select {
    margin-top: 12px !important;
  }
  .multiselectcomponent .multiselect__tags {
    min-height: calc(3.5rem + 2px);
    border-radius: 0.8rem;
    border-color: #dee2e6 !important;
    padding-top: calc(1.5rem + 4px);
  }

  .multiselectcomponent .multiselect__tag {
    margin-bottom: 0px !important;
  }

  .multiselectcomponent .multiselect--active, .multiselectcomponent .multiselect__content-wrapper {
    z-index: 100;
  }
</style>
